"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var autoBind = require("auto-bind");
var FontFaceObserver = require("fontfaceobserver");
var Font_1 = require("./Font");
var FONT_STYLE_TO_ANIMATION_STYLE_MAP = (_a = {},
    _a[Font_1.FontStyle.REGULAR] = "Regular",
    _a[Font_1.FontStyle.ITALIC] = "Italic",
    _a[Font_1.FontStyle.BOLD] = "Bold",
    _a[Font_1.FontStyle.BOLD_ITALIC] = "Bold Italic",
    _a);
var FontLoaderImpl = (function () {
    function FontLoaderImpl() {
        autoBind(this);
        this.LOADED_FONTS_MAP = {};
    }
    FontLoaderImpl.prototype.loadAnimationFonts = function (animation) {
        var _this = this;
        var fontLoadPromises = animation.getFontsMap().map(function (f) { return _this.loadAnimationFont(f); });
        return Promise
            .all(fontLoadPromises)
            .then(function () {
            return;
        });
    };
    FontLoaderImpl.prototype.loadFont = function (font) {
        var dummyAnimationFont = {
            uid: font.uid,
            family: font.family,
            style: FONT_STYLE_TO_ANIMATION_STYLE_MAP[font.style],
            path: font.urls[0].url,
        };
        return this.loadAnimationFont(dummyAnimationFont);
    };
    FontLoaderImpl.prototype.loadAnimationFont = function (font) {
        var _this = this;
        console.log("Evaluating " + JSON.stringify(font));
        if (this.LOADED_FONTS_MAP[font.uid] === undefined) {
            console.log("Loading new font " + JSON.stringify(font));
            this.LOADED_FONTS_MAP[font.uid] = new Promise(function (resolve, reject) {
                var fontObserverVariant = {};
                var styleLines = [];
                styleLines.push("@font-face { font-family: '" + font.uid + "'; font-display: swap; src: url('" + font.path + "'); }");
                styleLines.push(".fnt-" + font.uid + " {\tfont-family: '" + font.uid + "';  }");
                var cssTag = document.createElement("style");
                cssTag.type = "text/css";
                cssTag.appendChild(document.createTextNode(styleLines.join('\n')));
                document.head.appendChild(cssTag);
                new FontFaceObserver(font.uid, fontObserverVariant)
                    .load(null, 5000)
                    .then(function () {
                    console.log("Loaded font: " + font.uid + " (" + font.family + ") from " + font.path);
                })
                    .catch(function (err) {
                    console.error("Error loading font: " + font.uid + " (" + font.family + ") - " + err);
                })
                    .finally(function () {
                    _this.LOADED_FONTS_MAP[font.family] = Promise.resolve();
                    resolve();
                });
            });
        }
        return this.LOADED_FONTS_MAP[font.uid];
    };
    return FontLoaderImpl;
}());
exports.FontLoader = new FontLoaderImpl();
//# sourceMappingURL=FontLoader.js.map